import React, { useState, useEffect, useContext } from 'react'
import { useDispatch } from 'react-redux'
import history from 'shared/utils/history'
import * as Actions from 'state/actions'
import { Auth0Lock } from 'auth0-lock'
import Emitter from 'shared/utils/emitter'

import logo from 'assets/flowai-logo-small.png'

const isDev = (process.env.IS_DEV === 'true' || process.env.IS_DEV === true)
const getInviteEmail = () => {
  if(typeof Storage !== 'undefined') {
    const inviteEmail = sessionStorage.getItem('inviteEmail')

    return inviteEmail
  }

  return null
}

const lock = new Auth0Lock(
  process.env.AUTH0_CLIENT_ID,
  process.env.AUTH0_DOMAIN,
  {
    theme: {
      logo,
      primaryColor: '#E40288'
    },
    languageDictionary: {
      //   emailInputPlaceholder: 'name@youremail.com',
      title: '',
      signUpTitle: 'Create a free account',
      forgotPasswordAction: 'Forgot your password?',
      signUpTerms: "I agree to the <a href='https://flow.ai/terms' target='_blank'>terms of service</a> and <a href='https://flow.ai/privacy-policy' target='_blank'>privacy policy</a>."
    },
    allowSignUp: isDev || getInviteEmail() ? true : false,
    mustAcceptTerms: true,
    auth: {
      redirectUrl: process.env.AUTH0_REDIRECT_URI,
      responseType: 'token id_token'
    },
    configurationBaseUrl: process.env.AUTH0_CONFIGURATION_BASE_URL,
    allowAutocomplete: true,
    autofocus: false,
    autoclose: true,
    rememberLastLogin: true,
    container: 'login-window',
    prefill: {
      email: getInviteEmail()
    }
  }
)

export const Auth0Context = React.createContext()
export const useAuth0 = () => useContext(Auth0Context)
export const Auth0Provider = ({
  children
}) => {
  //redux hook
  const dispatch = useDispatch()

  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [accessToken, setAccessToken] = useState(null)
  const [idToken, setIdToken] = useState(null)
  const [userProfile, setUserProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  const [isSignInOpen, setIsSignInOpen] = useState(false)
  const [isSignUpOpen, setIsSignUpOpen] = useState(false)

  useEffect(() => {
    const userInfoHandler = (error, profile) => {
      if (error) {
        console.error('Auth0Lock.getUserInfo :: catch an error ', error)
        return
      }

      setUserProfile(profile)
    }

    const errorEventHandler = eventName => error => {
      console.error(`Auth0Lock :: catch error "${eventName}" `, error)
    }

    lock.on('authenticated', authResult => {
      setIsAuthenticated(true)
      setAccessToken(authResult.accessToken)

      setIdToken(authResult.idToken)
      dispatch(Actions.setToken(authResult.idToken))
      dispatch(Actions.fetchProfile())

      lock.getUserInfo(authResult.accessToken, userInfoHandler)
    })

    lock.on('authorization_error', errorEventHandler('authorization_error'))
    lock.on('unrecoverable_error', errorEventHandler('unrecoverable_error'))

    lock.on('signup ready', () => {
      setIsSignInOpen(false)
      setIsSignUpOpen(true)

      history.push(`${process.env.CHAT_PUBLIC_PATH}/signup`)
    })
    lock.on('signin ready', () => {
      setIsSignInOpen(true)
      setIsSignUpOpen(false)

      history.push(`${process.env.CHAT_PUBLIC_PATH}/login`)
    })


    lock.checkSession({}, (error, authResult) => {
      if (error) {
        console.error('Auth0Lock.checkSession :: catch an error ', error)

        setLoading(false)
        return
      }

      setIsAuthenticated(true)
      setAccessToken(authResult.accessToken)

      setIdToken(authResult.idToken)
      dispatch(Actions.setToken(authResult.idToken))
      dispatch(Actions.fetchProfile())

      setLoading(false)

      lock.getUserInfo(authResult.accessToken, userInfoHandler)
    })
  }, [])

  Emitter.on('auth.check.session', () => {
    lock.checkSession({}, (error) => {
      if(error?.code === 'login_required' && isAuthenticated) {
        console.error('Auth0Lock.checkSession :: catch an error ', error)

        lock.logout({
          returnTo: process.env.AUTH0_REDIRECT_URI
        })

        setIsAuthenticated(false)
        return
      }

      if (error) {
        console.error('Auth0Lock.checkSession :: catch an error ', error)
        return
      }
    })
  })

  return (
    <Auth0Context.Provider
      value={{
        isAuthenticated,
        accessToken,
        idToken,
        loading,

        isSignInOpen,
        isSignUpOpen,

        profile: userProfile,
        login: options => lock.show(options),
        logout: () => {
          dispatch(Actions.authCheck())
          lock.logout({
            returnTo: process.env.AUTH0_REDIRECT_URI
          })
        }
      }}
    >
      {children}
    </Auth0Context.Provider>
  )
}
